export default "__VITE_ASSET__DgWnRXwK__"